var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHookedLarge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_62199",
    "data-name": "Group 62199",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 20.082,
    viewBox: "0 0 152 20.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22161",
    "data-name": "Rectangle 22161",
    width: 152,
    height: 20.081,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62198",
    "data-name": "Group 62198",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62197",
    "data-name": "Group 62197",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107499",
    "data-name": "Path 107499",
    d: "M209.718,14.115c0,4.578-3.6,8-8.489,8s-8.489-3.4-8.489-8c0-4.578,3.6-7.911,8.489-7.911s8.489,3.355,8.489,7.911m-12.245.022a3.964,3.964,0,0,0,3.822,4.111,3.86,3.86,0,0,0,3.689-4.111,3.82,3.82,0,0,0-3.689-4.067,3.91,3.91,0,0,0-3.822,4.067",
    transform: "translate(-127.974 -4.119)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107500",
    "data-name": "Path 107500",
    d: "M265,14.115c0,4.578-3.6,8-8.489,8s-8.489-3.4-8.489-8c0-4.578,3.6-7.911,8.489-7.911S265,9.559,265,14.115m-12.245.022a3.964,3.964,0,0,0,3.823,4.111,3.86,3.86,0,0,0,3.689-4.111,3.82,3.82,0,0,0-3.689-4.067,3.91,3.91,0,0,0-3.823,4.067",
    transform: "translate(-164.677 -4.119)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107501",
    "data-name": "Path 107501",
    d: "M316.338,22.179l-3.622-5.689-1.755,1.955v3.734h-4.622V6.6h4.622v6l5.222-6h5.333l-5.645,6.333,6,9.245Z",
    transform: "translate(-203.399 -4.382)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107502",
    "data-name": "Path 107502",
    d: "M372.034,6.6v3.556h-8.111V12.6h7.356v3.556h-7.356v2.466h8.334v3.556H359.3V6.6Z",
    transform: "translate(-238.565 -4.382)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107503",
    "data-name": "Path 107503",
    d: "M422.308,14.379c0,4.689-3.4,7.8-8.534,7.8h-6.667V6.6h6.822c5.045,0,8.378,3.089,8.378,7.778m-4.711.045c0-2.511-1.533-4.179-3.756-4.179h-2.111v8.312h2.333c2.111,0,3.533-1.644,3.533-4.133",
    transform: "translate(-270.307 -4.383)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107504",
    "data-name": "Path 107504",
    d: "M4.521,15.3a11.536,11.536,0,0,0,3.151.848,7.091,7.091,0,0,1-1.928-1.235A6.39,6.39,0,0,1,3.772,8.1,6.854,6.854,0,0,1,9.257,3.5a7.908,7.908,0,0,1,4.707.813c.112.061.217.135.325.2L11.9,5.868c-.126.093-.032.25.134.226a42.332,42.332,0,0,0,6.936-1.5c.086-.028.122-.069.127-.111a.127.127,0,0,0,.016-.033.469.469,0,0,0-.119-.379A11.587,11.587,0,0,0,7.7.316,10.431,10.431,0,0,0,.45,7.037c-.617,1.839-.758,4.267.61,5.849A10.776,10.776,0,0,0,4.521,15.3",
    transform: "translate(0 -0.001)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107505",
    "data-name": "Path 107505",
    d: "M15.01,15.193a8.193,8.193,0,0,1-4.98,1.521A12.319,12.319,0,0,1,5.1,15.724a11.185,11.185,0,0,1-3.95-2.877,10.244,10.244,0,0,0,3,4.6,10.005,10.005,0,0,0,10.656,1.843A14.035,14.035,0,0,0,20.025,15.1c1.538-1.883,2.862-3.921,4.258-5.908,1.554-2.211,3.275-4.45,5.912-5.385a11.123,11.123,0,0,1,7.869.552,11.182,11.182,0,0,1,3.95,2.876,10.236,10.236,0,0,0-3-4.6A10.006,10.006,0,0,0,28.358.795a13.872,13.872,0,0,0-5.089,4.042c-1.649,1.978-3.008,4.17-4.535,6.239a20.894,20.894,0,0,1-3.3,3.791q-.207.172-.419.326",
    transform: "translate(-0.767 0)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107506",
    "data-name": "Path 107506",
    d: "M85.02,15.012a8.677,8.677,0,0,0-3.407-2.454,11.532,11.532,0,0,0-3.152-.848,7.092,7.092,0,0,1,1.929,1.235,6.388,6.388,0,0,1,1.972,6.81,6.853,6.853,0,0,1-5.485,4.605,7.9,7.9,0,0,1-4.707-.813c-.112-.061-.217-.135-.325-.2l2.392-1.355c.126-.093.032-.251-.135-.226a42.3,42.3,0,0,0-6.936,1.5c-.086.028-.122.069-.127.111-.005.011-.015.02-.016.033a.472.472,0,0,0,.119.379,12.947,12.947,0,0,0,3.33,2.757,10.891,10.891,0,0,0,11.873-.982,10.145,10.145,0,0,0,3.688-6.333,5.274,5.274,0,0,0-1.01-4.213",
    transform: "translate(-44.498 -7.774)",
    fill: "#1228f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_107498",
    "data-name": "Path 107498",
    d: "M145.59,6.6v6.2h5.533V6.6h4.622V22.179h-4.622v-5.8H145.59v5.8h-4.622V6.6Z",
    transform: "translate(-93.599 -4.382)",
    fill: "#1228f3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHookedLarge);
export default __webpack_public_path__ + "static/media/hooked-large.6512926a624a6385a35959fe0141a121.svg";
export { ForwardRef as ReactComponent };